<template>
  <b-overlay :show="isLoading" rounded="sm">
    <div v-if="loaded">
      <b-row v-if="summary.length" class="mb-1">
        <b-col v-for="item in summary" :key="item.chart_slug" md="4">
          <b-card border-variant="primary" class="mb-1">
            <h6 class="mb-50">{{ item.chart_name }}</h6>
            <div>Хитов: <strong>{{ item.hits }}</strong></div>
            <div>№1: <strong>{{ item.number_ones }}</strong></div>
            <div>Лучший пик: <strong>#{{ item.best_peak }}</strong></div>
            <div>Недель всего: <strong>{{ item.weeks_total }}</strong></div>
          </b-card>
        </b-col>
      </b-row>
      <b-form-radio-group
          v-if="summary.length > 1"
          v-model="chartFilter"
          :options="filterOptions"
          buttons
          size="sm"
          button-variant="outline-primary"
          class="mb-1"
      />
      <chart-stats-table :songs="songs" :chart-filter="chartFilter"/>
    </div>
  </b-overlay>
</template>

<script>
import { BOverlay, BRow, BCol, BCard, BFormRadioGroup } from 'bootstrap-vue'
import { computed, ref } from '@vue/composition-api'
import { useToast } from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import chartsApi from './chartsApi'
import ChartStatsTable from './ChartStatsTable.vue'

export default {
  components: {
    BOverlay, BRow, BCol, BCard, BFormRadioGroup, ChartStatsTable,
  },
  props: {
    artistId: { type: [Number, String], required: true },
  },
  setup(props) {
    const toast = useToast()
    const isLoading = ref(false)
    const loaded = ref(false)
    const summary = ref([])
    const songs = ref([])
    const chartFilter = ref(null)

    const filterOptions = computed(() => [
      { text: 'Все', value: null },
      ...summary.value.map(item => ({ text: item.chart_name, value: item.chart_slug })),
    ])

    // Грузится лениво — по первому клику на вкладку (родитель зовёт через ref)
    const load = async () => {
      if (loaded.value || isLoading.value) return
      isLoading.value = true
      try {
        const res = await chartsApi.fetchArtistCharts(props.artistId)
        summary.value = res.data.data.summary
        songs.value = res.data.data.songs
        loaded.value = true
      } catch (e) {
        toast({
          component: ToastificationContent,
          props: { title: 'Не удалось загрузить чарты артиста', icon: 'AlertTriangleIcon', variant: 'danger' },
        })
      } finally {
        isLoading.value = false
      }
    }

    return {
      isLoading, loaded, summary, songs, chartFilter, filterOptions, load,
    }
  },
}
</script>
